import { ContextMenu, type Props as ContextMenuProps } from '~/components/ContextMenu/ContextMenu';
import { MoreHorizontalIcon } from '~/components/Icon/MoreHorizontalIcon';
import styles from './Table.module.css';

export function Context(props: Omit<ContextMenuProps, 'trigger'>) {
  return (
    <ContextMenu
      trigger={
        <button className={styles.contextButton} aria-label="Visa / Dölj meny">
          <MoreHorizontalIcon />
        </button>
      }
      {...props}
    />
  );
}
